<template>
  <div class="p--40px">
    <h1 class="font--32px lh--1 pb--20px">My Compnay Info</h1>
    <form
      @submit.prevent="submit"
      @input="error.errorMessage = ''"
    >
      <text-field-editor
        :required="true"
        :error="error"
        :url="''"
        :uuid="''"
        v-model="row.terms1"
        label="이용약관"
        name="terms1"
      ></text-field-editor>

      <text-field-editor
        :required="true"
        :error="error"
        :url="''"
        :uuid="''"
        v-model="row.terms2"
        label="개인정보처리지침"
        name="terms2"
      ></text-field-editor>

      <div class="pt--20px text--center">
        <button
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="$router.push({ name: 'adminMain' })"
        >
          돌아가기
        </button>

        <button
          type="submit"
          class="btn btn--xxxl black text--white ml--4px"
        >저장하기</button>
      </div>
    </form>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      row: {
        terms1: '',
        terms2: ''
      },
      origin: {},
      error: {}
    }
  },
  computed: {
    ...mapState(['company'])
  },
  async created () {
    await this.$load(`/api/companys/${this.company.companyId}`)
  },
  methods: {
    async submit () {
      try {
        let ret = await this.$update(`/api/companys/${this.row.companyId}/terms`)
        if (!ret) {
          return
        }
        this.$router.push({ name: 'adminMain' })
      } catch (error) {
        this.error = error
      }
    }
  },
  components: {
    TextFieldEditor: () => import('@/component/ui2/textfield/TextFieldEditor')
  }
}
</script>
